import { useEffect, useState } from 'react';

/**
 * Custom hook for managing collapsible component state.
 *
 * @param defaultCollapsed - Optional default collapsed state. When this changes, the internal state syncs to it.
 */
export const useCollapse = (defaultCollapsed?: boolean) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed ?? false);

  // Sync internal state when defaultCollapsed changes
  useEffect(() => {
    if (defaultCollapsed !== undefined) {
      setIsCollapsed(defaultCollapsed);
    }
  }, [defaultCollapsed]);

  const onCollapseChange = (collapsed: boolean) => {
    setIsCollapsed(collapsed);
  };

  return {
    isCollapsed,
    onCollapseChange,
  };
};
